
const geolocationModalLocales = {
  en: {
    titleLocation: 'Your location is set to',
    titleLanguage: 'Your language is set to',
    shopIn: 'Shop in',
    shippingOptions: 'Get shipping options for',
    languageSetTo: 'Language set to',
    continue: 'Continue',
    changeCountryLanguage: 'Change country / language',
    changeLanguage: 'Select language',
    country: 'Country',
    language: 'Language',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    infoCountryNotAvailableForShipping:
      'If your country isn’t listed, it indicates that shipping to that location is currently unavailable.',
  },
  fr: {
    titleLocation: 'Votre emplacement est défini sur',
    titleLanguage: 'Votre langue est définie sur',
    shopIn: 'Acheter en',
    shippingOptions: 'Obtenir les options de livraison pour',
    languageSetTo: 'Langue définie sur',
    continue: 'Continuer',
    changeCountryLanguage: 'Changer de pays / langue',
    changeLanguage: 'Sélectionner la langue',
    country: 'Pays',
    language: 'Langue',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    infoCountryNotAvailableForShipping:
      'Si votre pays n’est pas répertorié, cela signifie que la livraison à cet endroit n’est actuellement pas disponible.',
  },
  nl: {
    titleLocation: 'Je locatie is ingesteld op',
    titleLanguage: 'Je taal is ingesteld op',
    shopIn: 'Winkel in',
    shippingOptions: 'Verzendopties voor',
    languageSetTo: 'Taal ingesteld op',
    continue: 'Doorgaan',
    changeCountryLanguage: 'Wijzig land / taal',
    changeLanguage: 'Taal selecteren',
    country: 'Land',
    language: 'Taal',
    submit: 'Versturen',
    back: 'Terug',
    close: 'Sluiten',
    infoCountryNotAvailableForShipping:
      'Als uw land niet in de lijst staat, betekent dit dat verzending naar die locatie momenteel niet beschikbaar is.',
  },
  de: {
    titleLocation: 'Ihre Standort ist auf',
    titleLanguage: 'Ihre Sprache ist auf',
    shopIn: 'Shop in',
    shippingOptions: 'Erhalte Versandoptionen für',
    languageSetTo: 'Sprache auf',
    continue: 'Weiter',
    changeCountryLanguage: 'Land / Sprache ändern',
    changeLanguage: 'Sprache wählen',
    country: 'Land',
    language: 'Sprache',
    submit: 'Einreichen',
    back: 'Zurück',
    close: 'Schließen',
    infoCountryNotAvailableForShipping:
      'Wenn Ihr Land nicht aufgeführt ist, bedeutet dies, dass der Versand an diesen Ort derzeit nicht möglich ist.',
  },
  es: {
    titleLocation: 'Tu ubicación está configurada en',
    titleLanguage: 'Tu idioma está configurado en',
    shopIn: 'Comprar en',
    shippingOptions: 'Obtener opciones de envío para',
    languageSetTo: 'Idioma configurado en',
    continue: 'Continuar',
    changeCountryLanguage: 'Cambiar país / idioma',
    changeLanguage: 'Cambiar idioma',
    country: 'País',
    language: 'Idioma',
    submit: 'Enviar',
    back: 'Volver',
    close: 'Cerrar',
    infoCountryNotAvailableForShipping:
      'Si tu país no está en la lista, esto indica que el envío a esa ubicación no está disponible actualmente.',
  },
  it: {
    titleLocation: 'La tua posizione è impostata su',
    titleLanguage: 'La tua lingua è impostata su',
    shopIn: 'Compra in',
    shippingOptions: 'Ottieni opzioni di spedizione per',
    languageSetTo: 'Lingua impostata su',
    continue: 'Continua',
    changeCountryLanguage: 'Cambia paese / lingua',
    changeLanguage: 'Lingua selezionare',
    country: 'Paese',
    language: 'Lingua',
    submit: 'Invia',
    back: 'Indietro',
    close: 'Chiudi',
    infoCountryNotAvailableForShipping:
      'Se il tuo paese non è elencato, significa che la spedizione verso quella località non è attualmente disponibile.',
  },
  pt: {
    titleLocation: 'Sua localização está definida em',
    titleLanguage: 'Seu idioma está definido em',
    shopIn: 'Comprar em',
    shippingOptions: 'Obtenha opções de envio para',
    languageSetTo: 'Idioma definido em',
    continue: 'Continuar',
    changeCountryLanguage: 'Alterar país / idioma',
    changeLanguage: 'Selecionar idioma',
    country: 'País',
    language: 'Idioma',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar',
    infoCountryNotAvailableForShipping:
      'Se o seu país não estiver listado, isso indica que o envio para esse local não está disponível no momento.',
  },
};

async function fetchStorefrontApi(storefrontApiAccessToken, query, variables = {}) {
  if (!storefrontApiAccessToken) {
    console.error('Storefront API access token is not set');
    return null;
  }

  const endpoint = `https://${window.Shopify.shop}/api/2024-10/graphql.json`;
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontApiAccessToken,
    },
    body: JSON.stringify({ query, variables }),
  });

  const { data, errors } = await response.json();

  if (errors) {
    throw new Error(errors[0].message);
  }

  return data;
}

function generateModalTemplate(suggestions, localization) {
  const {
    recommendedCountry,
    recommendedCountryCode,
    recommendedCurrency,
    recommendedLanguage,
    recommendedLanguageCode,
  } = suggestions;

  let translations = geolocationModalLocales.en;
  if (geolocationModalLocales[recommendedLanguageCode]) {
    translations = geolocationModalLocales[recommendedLanguageCode];
  }

  const recommendedLanguageCodeToUpperCase = recommendedLanguageCode
    ? recommendedLanguageCode.toUpperCase()
    : 'EN';
  const showRecommendedCountryLanguage = localization.availableCountries.some(
    (country) =>
      country.isoCode === recommendedCountryCode &&
      country.availableLanguages.some(
        (language) => language.isoCode === recommendedLanguageCodeToUpperCase,
      ),
  );

  const localizationCountriesCount = localization.availableCountries.length;
  const localizationCurrenciesAreDifferent = localization.availableCountries.some(
    (country) => country.currency.isoCode !== recommendedCurrency,
  );

  const localizationCountryOptions = localization.availableCountries.map((country) => {
    const { isoCode, name } = country;
    let currencyIsoCode = null;
    if (country.currency && localizationCurrenciesAreDifferent) {
      currencyIsoCode = country.currency.isoCode;
    }

    return `<option value="${isoCode}"${
      isoCode === recommendedCountryCode ? ' selected' : ''
    }>${name}${currencyIsoCode ? ` (${currencyIsoCode})` : ''}</option>`;
  });

  const showRecommendedCountry = recommendedCountry && localizationCountriesCount > 1;
  let recommendedCountryFlag = '';
  if (showRecommendedCountry) {
    recommendedCountryFlag = `https://cdn.shopify.com/static/images/flags/${recommendedCountryCode.toLowerCase()}.svg`;
  }

  const geolocationRecommendedContent = `
    <div class="geolocation__content | js-geolocation-recommended">
      ${
        showRecommendedCountry
          ? `<div class="geolocation__flag">
            <img src="${recommendedCountryFlag}" alt="${recommendedCountry}" width="75" height="48" />
          </div>`
          : ''
      }

      <p class="geolocation__title">
        ${
          showRecommendedCountry
            ? `${translations.titleLocation} ${recommendedCountry}`
            : `${translations.titleLanguage} ${recommendedLanguage}`
        }
      </p>

      ${
        showRecommendedCountry
          ? `<ul class="geolocation__body">
              ${
                recommendedCurrency && localizationCurrenciesAreDifferent
                  ? `<li>${translations.shopIn} ${recommendedCurrency}</li>`
                  : ''
              }
              ${
                recommendedCountry
                  ? `<li>${translations.shippingOptions} ${recommendedCountry}</li>`
                  : ''
              }
              ${
                recommendedLanguage
                  ? `<li>${translations.languageSetTo} ${recommendedLanguage}</li>`
                  : ''
              }
            </ul>`
          : ''
      }

      <div class="geolocation__ctas">
        <form action="/localization" method="post">
          <input type="hidden" name="_method" value="PUT" />
          <input type="hidden" name="return_to" value="${window.location.pathname}" />
          <input type="hidden" name="country_code" value="${recommendedCountryCode}">
          <input type="hidden" name="language_code" value="${recommendedLanguageCode}">

          <button type="submit" class="button button--full | js-geolocation-submit">
            ${translations.continue}
          </button>
        </form>

        <button class="geolocation__cta | js-geolocation-change">
          ${
            showRecommendedCountry
              ? translations.changeCountryLanguage
              : translations.changeLanguage
          }
        </button>
      </div>
    </div>
  `;

  return `
    ${showRecommendedCountryLanguage ? geolocationRecommendedContent : ''}

    <div class="geolocation__content | js-geolocation-select"${
      showRecommendedCountryLanguage ? ' style="display: none;"' : ''
    }>
      <div class="geolocation__title">
        ${translations.changeCountryLanguage}
      </div>

      ${
        !showRecommendedCountry
          ? `<div class="geolocation__info">
              ${translations.infoCountryNotAvailableForShipping}
            </div>`
          : ''
      }

      <div class="geolocation__form-wrapper">
        <form action="/localization" method="post" class="geolocation__form">
          <input type="hidden" name="_method" value="PUT" />
          <input type="hidden" name="return_to" value="${window.location.pathname}" />

          <div class="geolocation__select">
            <label for="GeolocationCountrySelect" class="vh">${translations.country}</label>
            <select id="GeolocationCountrySelect" name="country_code" class="select">
              ${localizationCountryOptions.join('')}
            </select>
          </div>

          <div class="geolocation__select">
            <label for="GeolocationLanguageSelect" class="vh">${translations.language}</label>
            <select id="GeolocationLanguageSelect" name="language_code" class="select">
            </select>
          </div>
          <button type="submit" class="button button--full | js-geolocation-submit">${
            translations.submit
          }</button>
        </form>

        ${
          showRecommendedCountryLanguage
            ? `<button class="geolocation__cta | js-geolocation-back">${translations.back}</button>`
            : ''
        }
      </div>
    </div>

    <button type="button" class="esign-modal__close | js-modal-close">
      <div class="icon icon-close">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.1 17.1">
          <path d="M17.1 1.1 16 0 8.5 7.5 1.1 0 0 1.1l7.5 7.4L0 16l1.1 1.1 7.4-7.5 7.5 7.5 1.1-1.1-7.5-7.5 7.5-7.4z"/>
        </svg>
      </div>
      <span class="vh">${translations.close}</span>
    </button>
  `;
}

class GeolocationModal extends HTMLElement {
  constructor() {
    super();
    this.modalNamespace = 'geolocation-modal';
    this.modalEl = document.getElementById(this.modalNamespace);

    if (this.modalEl && !window.Shopify.designMode) {
      this.cookieName = 'geolocation_modal_accepted';
      this.cookieValue = '1';
      this.defaultLanguage = 'EN';

      const cookieRow = document.cookie.split('; ').find((row) => row.startsWith(this.cookieName));
      const currentCookieValue = cookieRow ? cookieRow.split('=')[1].toString() : null;

      const { key } = this.modalEl.dataset;
      this.storefrontApiAccessToken = key;

      if (!currentCookieValue || currentCookieValue !== this.cookieValue) {
        this.getModal();
      }
    }
  }

  setGeolocationCookie() {
    document.cookie = `${this.cookieName}=${this.cookieValue}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;`;
  }

  async fetchGeolocationSuggestions() {
    try {
      const suggestionsResponse = await fetch(
        `${window.Shopify.routes.root}browsing_context_suggestions.json` +
          `?country[enabled]=true` +
          `&currency[enabled]=true` +
          `&language[enabled]=true`,
      ).then((r) => r.json());

      let recommendedLanguage = null;
      let recommendedLanguageCode = null;
      let recommendedCountry = null;
      let recommendedCountryCode = null;
      let recommendedCurrency = null;
      let recommendedCurrencyName = null;

      if (suggestionsResponse.suggestions.length > 0) {
        const suggestions = suggestionsResponse.suggestions[0];
        const {
          country: countryParts,
          language: languageParts,
          currency: currencyParts,
        } = suggestions.parts;

        if (languageParts) {
          recommendedLanguage = languageParts.name;
          recommendedLanguageCode = languageParts.handle;
        }

        if (countryParts) {
          recommendedCountry = countryParts.name;
          recommendedCountryCode = countryParts.handle;
        }

        if (currencyParts) {
          recommendedCurrency = currencyParts.handle;
          recommendedCurrencyName = currencyParts.name;
        }
      }

      return {
        recommendedLanguage,
        recommendedLanguageCode,
        recommendedCountry,
        recommendedCountryCode,
        recommendedCurrency,
        recommendedCurrencyName,
      };
    } catch (error) {
      console.error('Error fetching geolocation suggestions:', error);
      return null;
    }
  }

  async fetchLocalization() {
    const defaultLanguageCode = this.defaultLanguage;
    const languageCode = this.suggestions.recommendedLanguageCode || defaultLanguageCode;

    const LOCALIZATION_QUERY = `
      query AllLocalizations @inContext(language: ${languageCode.toUpperCase()}) {
        localization {
          availableCountries {
            isoCode
            name
            currency {
              isoCode
            }
            availableLanguages {
              isoCode
              endonymName
            }
          }
        }
      }
    `;

    const response = await fetchStorefrontApi(this.storefrontApiAccessToken, LOCALIZATION_QUERY);
    if (!response) {
      return null;
    }

    return response.localization;
  }

  async getModal() {
    this.suggestions = await this.fetchGeolocationSuggestions();

    let isCurrentMarketDifferentFromRecommendedMarket = true;
    if (this.suggestions.recommendedLanguageCode && this.suggestions.recommendedCountryCode) {
      isCurrentMarketDifferentFromRecommendedMarket =
        window.Shopify.locale !== this.suggestions.recommendedLanguageCode ||
        window.Shopify.country !== this.suggestions.recommendedCountryCode;
    }

    console.log('isCurrentMarketDifferentFromRecommendedMarket', isCurrentMarketDifferentFromRecommendedMarket);

    if (isCurrentMarketDifferentFromRecommendedMarket) {
      this.localization = await this.fetchLocalization();
    }

    console.log('this.localization', this.localization);

    if (!this.suggestions.recommendedLanguageCode && this.suggestions.recommendedCountryCode) {
      const selectedCountry = this.localization.availableCountries.find(
        (country) => country.isoCode === this.suggestions.recommendedCountryCode,
      );

      const isOnlyOneLanguage = selectedCountry.availableLanguages.length === 1;

      if (isOnlyOneLanguage) {
        const selectedLanguage = selectedCountry.availableLanguages[0];
        this.suggestions.recommendedLanguageCode = selectedLanguage.isoCode.toLowerCase();
        this.suggestions.recommendedLanguage = selectedLanguage.endonymName;

        this.localization = await this.fetchLocalization();

        const selectedCountryLocalization = this.localization.availableCountries.find(
          (country) => country.isoCode === this.suggestions.recommendedCountryCode,
        );
        this.suggestions.recommendedCountry = selectedCountryLocalization.name;
        this.suggestions.recommendedCountryCode = selectedCountryLocalization.isoCode;

        isCurrentMarketDifferentFromRecommendedMarket =
          window.Shopify.locale !== this.suggestions.recommendedLanguageCode ||
          window.Shopify.country !== this.suggestions.recommendedCountryCode;
      }
    }

    if (!isCurrentMarketDifferentFromRecommendedMarket) {
      this.setGeolocationCookie();
    }

    if (this.localization && isCurrentMarketDifferentFromRecommendedMarket) {
      const modalTemplate = generateModalTemplate(this.suggestions, this.localization);
      const modalContainerEl = document.getElementById('geolocation-container');
      if (modalContainerEl) {
        modalContainerEl.innerHTML = modalTemplate;
      }

      this.handleFormEvents();


      console.log('window.modalManager', window.modalManager);
      const modal = window.modalManager.idModalMap.get(this.modalNamespace);
      console.log('modal', modal);
      if (modal) {
        console.log('modal.show()');
        modal.show();
      }

      this.modalEl.querySelectorAll('.js-modal-close').forEach((el) => {
        el.addEventListener('click', () => {
          modal.hide();
          this.setGeolocationCookie();
        });
      });

      this.modalEl.querySelectorAll('.js-geolocation-submit').forEach((el) => {
        el.addEventListener('click', () => {
          this.setGeolocationCookie();
        });
      });

      modal.addEventListener('before-hide', () => {
        this.setGeolocationCookie();
      });
    }
  }

  handleFormEvents() {
    this.countrySelect = this.modalEl.querySelector('select[name="country_code"]');
    this.languageSelect = this.modalEl.querySelector('select[name="language_code"]');
    this.recommendedModal = this.modalEl.querySelector('.js-geolocation-recommended');
    this.selectMarketModal = this.modalEl.querySelector('.js-geolocation-select');

    this.changeButton = this.modalEl.querySelector('.js-geolocation-change');
    this.backButton = this.modalEl.querySelector('.js-geolocation-back');

    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', this.handleCountrySelectChange.bind(this));
    }

    if (this.changeButton) {
      this.changeButton.addEventListener('click', this.handleViewSelectMarket.bind(this));
    }

    if (this.backButton) {
      this.backButton.addEventListener('click', this.handleViewRecommended.bind(this));
    }

    this.renderLanguageOptions(
      this.suggestions.recommendedCountryCode,
      this.suggestions.recommendedLanguageCode,
    );
  }

  handleCountrySelectChange() {
    const selectedCountry = this.countrySelect.value;
    this.renderLanguageOptions(selectedCountry, this.suggestions.recommendedLanguageCode);
  }

  renderLanguageOptions(countryCode, preselectedLanguageCodeSuggestion) {
    if (!this.localization.availableCountries.length) {
      return;
    }

    const preselectedLanguageCode = preselectedLanguageCodeSuggestion || this.defaultLanguage;
    let selectedCountry = this.localization.availableCountries.find(
      (country) => country.isoCode === countryCode,
    );

    if (!selectedCountry) {
      [selectedCountry] = this.localization.availableCountries;
    }

    let preselectedLanguage = null;
    if (selectedCountry) {
      preselectedLanguage = selectedCountry.availableLanguages.find(
        (language) => language.isoCode === preselectedLanguageCode.toUpperCase(),
      );
    }

    let selectedLanguageCode = preselectedLanguage ? preselectedLanguage.isoCode : null;

    if (!selectedLanguageCode && selectedCountry) {
      const currentLanguageCode = window.Shopify.locale;
      const currentLanguage = selectedCountry.availableLanguages.find(
        (language) => language.isoCode === currentLanguageCode.toUpperCase(),
      );
      selectedLanguageCode = currentLanguage ? currentLanguage.isoCode : null;
    }

    if (!selectedLanguageCode && selectedCountry && selectedCountry.availableLanguages.length > 0) {
      selectedLanguageCode = selectedCountry.availableLanguages[0].isoCode;
    }

    const languageOptions = selectedCountry.availableLanguages.map((language) => {
      const isSelected =
        selectedLanguageCode && language.isoCode === selectedLanguageCode.toUpperCase();
      return `<option value="${language.isoCode}" ${isSelected ? 'selected' : ''}>${
        language.endonymName
      }</option>`;
    });

    this.languageSelect.innerHTML = languageOptions.join('');
  }

  handleViewSelectMarket() {
    this.recommendedModal.style.display = 'none';
    this.selectMarketModal.style.display = 'block';
  }

  handleViewRecommended() {
    this.recommendedModal.style.display = 'block';
    this.selectMarketModal.style.display = 'none';
  }
}

customElements.define('geolocation-modal', GeolocationModal);
